import React from 'react';
import {connect} from 'react-redux';

import HeaderRate from './../rates/HeaderRate.jsx';

class DoubleOutcome extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        outcome: React.PropTypes.object,
        gridLocalization: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {section, outcome, gridLocalization} = this.props;

        if (outcome === undefined) {
            return (
                <span className="cell-title-wrapper">
                    <span className="cell rate empty-cell">{'\u00A0'}</span>
                    <span className="cell rate empty-cell">{'\u00A0'}</span>
                    <span className="cell rate empty-cell">{'\u00A0'}</span>
                </span>
            );
        }

        const outcomeRates = [];

        outcome.get('rates')
            .entrySeq()
            .sortBy((r) => r[0])
            .forEach((r) => {
                outcomeRates.push(r[1]);
            });

        const props = {
            section,
            gridLocalization
        };

        return (
            <span className="cell-title-wrapper">
                <HeaderRate key={outcomeRates[0]} id={outcomeRates[0]} {...props} />
                <HeaderRate key={outcomeRates[1]} id={outcomeRates[1]} {...props} />
                <HeaderRate key={outcomeRates[2]} id={outcomeRates[2]} {...props} />
            </span>
        );
    }
}

function select(state, props) {
    const {section, id} = props;
    let outcome;

    if (id && id !== null) {
        outcome = state.application.getIn([section, 'outcomes', id]);
    }

    return {
        section,
        outcome
    };
}

export default connect(select)(DoubleOutcome);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/header/DoubleOutcome.jsx